export default __webpack_public_path__ + "static/hashnode-e27c9984dcb0a0b44cd37f9932f24f0c.png";